import React from 'react';

const blurFocusedNumberInputOnWheel = (
    numberInputWheelEvent: React.WheelEvent<HTMLInputElement>
): void => {
    numberInputWheelEvent.currentTarget.blur();
};

const WorkyNumberInput: React.FC<React.InputHTMLAttributes<HTMLInputElement>> = ({
    onWheel,
    ...numberInputProps
}) => {
    const handleNumberInputWheel = (numberInputWheelEvent: React.WheelEvent<HTMLInputElement>): void => {
        blurFocusedNumberInputOnWheel(numberInputWheelEvent);
        onWheel?.(numberInputWheelEvent);
    };

    return (
        <input
            {...numberInputProps}
            type="number"
            onWheel={handleNumberInputWheel}
        />
    );
};

export { WorkyNumberInput };
